module.exports = __webpack_public_path__ + "static/media/S (55).506e4990.jpg";